type AuthRecoveryHandlers = {
  refreshAccessToken: () => Promise<string>;
  onUnauthorized: () => void;
};

let accessToken: string | null = null;
let recoveryHandlers: AuthRecoveryHandlers | null = null;
let refreshPromise: Promise<string> | null = null;

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string): void => {
  accessToken = token;
};

export const clearAccessToken = (): void => {
  accessToken = null;
};

export const configureAuthRecovery = (
  handlers: AuthRecoveryHandlers,
): (() => void) => {
  recoveryHandlers = handlers;
  return () => {
    if (recoveryHandlers === handlers) recoveryHandlers = null;
  };
};

export const recoverAccessToken = async (): Promise<string | null> => {
  if (!recoveryHandlers) return null;

  if (!refreshPromise) {
    refreshPromise = recoveryHandlers.refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

export const notifyUnauthorized = (): void => {
  clearAccessToken();
  recoveryHandlers?.onUnauthorized();
};
